import { Component } from '@angular/core';

@Component({
  selector: 'bo-notfound',
  templateUrl: './notfound.component.html',
  standalone: false,
})
export class NotfoundComponent {}
